/* epi-favorites.js — Wishlist Plus integration
   Requires Wishlist Plus (swym) app. If not installed, buttons stay disabled. */
(function () {
  'use strict';

  function init() {
    const btns = document.querySelectorAll('[data-wishlist-plus-trigger]');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      const productId = parseInt(btn.dataset.productId, 10);
      if (!productId) return;

      updateState(btn, productId);

      btn.addEventListener('click', function () {
        toggleFavorite(btn, productId);
      });
    });
  }

  function isInList(productId) {
    if (typeof window.swymCallbacks === 'undefined') return false;
    const list = window._swat && window._swat.getWishList ? window._swat.getWishList() : [];
    return list.some(function (item) { return item.empi === productId; });
  }

  function updateState(btn, productId) {
    const inList = isInList(productId);
    const label = btn.querySelector('[data-favorites-label]');
    const icon = btn.querySelector('[data-favorites-icon]');
    btn.classList.toggle('is-favorited', inList);
    if (label) label.textContent = inList ? btn.dataset.inFavoritesLabel : btn.dataset.addFavoritesLabel;
    if (icon) icon.setAttribute('data-filled', inList ? 'true' : 'false');
  }

  function toggleFavorite(btn, productId) {
    if (typeof window._swat === 'undefined') return;
    const inList = isInList(productId);
    if (inList) {
      window._swat.removeFromWishList({ empi: productId }, function () { updateState(btn, productId); });
    } else {
      const variantId = parseInt(document.querySelector('.product-variant-id')?.value || '0', 10);
      window._swat.addToWishList({ empi: productId, epi: variantId || productId }, function () { updateState(btn, productId); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run after swym initialises (it fires this event) */
  document.addEventListener('swym:api-loaded', init);
})();
